module.exports = __webpack_public_path__ + "static/media/1028179.691e3731.jpg";